import { Type } from "class-transformer";

export class DocumentVatTableItemDTO {
	public cost?: number;
	public gross: number;
	public net: number;
	public vat: number;
	public vatRateId: number;

	public currencyGross?: number;
	public currencyNet?: number;
	public currencyVat?: number;
	public manual?: boolean;
}

export class DocumentVatTableDTO {
	@Type(() => DocumentVatTableItemDTO) public items: DocumentVatTableItemDTO[];
}
